import { UPDATE_FACTURAS } from '../actionTypes';

export const updateFacturas = (payload) => ({
	type: UPDATE_FACTURAS,
	payload,
});
